/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/DashboardPageBlockReport', 'model/DashboardPageBlock', 'model/DashboardPageBlockReportNestedPaginationSlice', 'model/DashboardPageBlockReportPaginationSlice'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/DashboardPageBlockReport'), require('../model/DashboardPageBlock'), require('../model/DashboardPageBlockReportNestedPaginationSlice'), require('../model/DashboardPageBlockReportPaginationSlice'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.DashboardPageBlockApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.DashboardPageBlockReport, root.ForStractionServiceApi.DashboardPageBlock, root.ForStractionServiceApi.DashboardPageBlockReportNestedPaginationSlice, root.ForStractionServiceApi.DashboardPageBlockReportPaginationSlice);
  }
}(this, function(ApiClient, DashboardPageBlockReport, DashboardPageBlock, DashboardPageBlockReportNestedPaginationSlice, DashboardPageBlockReportPaginationSlice) {
  'use strict';

  /**
   * DashboardPageBlock service.
   * @module api/DashboardPageBlockApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new DashboardPageBlockApi. 
   * @alias module:api/DashboardPageBlockApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the dashboardPageBlockAddFromTemplatePut operation.
     * @callback module:api/DashboardPageBlockApi~dashboardPageBlockAddFromTemplatePutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addFromTemplate
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {Integer} templateID 
     * @param {Integer} pageID 
     * @param {Integer} x 
     * @param {Integer} y 
     * @param {Integer} width 
     * @param {Integer} height 
     * @param {module:api/DashboardPageBlockApi~dashboardPageBlockAddFromTemplatePutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.dashboardPageBlockAddFromTemplatePut = function(_4SAPIAppID, body, templateID, pageID, x, y, width, height, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dashboardPageBlockAddFromTemplatePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling dashboardPageBlockAddFromTemplatePut";
      }

      // verify the required parameter 'templateID' is set
      if (templateID == undefined || templateID == null) {
        throw "Missing the required parameter 'templateID' when calling dashboardPageBlockAddFromTemplatePut";
      }

      // verify the required parameter 'pageID' is set
      if (pageID == undefined || pageID == null) {
        throw "Missing the required parameter 'pageID' when calling dashboardPageBlockAddFromTemplatePut";
      }

      // verify the required parameter 'x' is set
      if (x == undefined || x == null) {
        throw "Missing the required parameter 'x' when calling dashboardPageBlockAddFromTemplatePut";
      }

      // verify the required parameter 'y' is set
      if (y == undefined || y == null) {
        throw "Missing the required parameter 'y' when calling dashboardPageBlockAddFromTemplatePut";
      }

      // verify the required parameter 'width' is set
      if (width == undefined || width == null) {
        throw "Missing the required parameter 'width' when calling dashboardPageBlockAddFromTemplatePut";
      }

      // verify the required parameter 'height' is set
      if (height == undefined || height == null) {
        throw "Missing the required parameter 'height' when calling dashboardPageBlockAddFromTemplatePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'templateID': templateID,
        'pageID': pageID,
        'x': x,
        'y': y,
        'width': width,
        'height': height
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/DashboardPageBlock/addFromTemplate', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the dashboardPageBlockAddPut operation.
     * @callback module:api/DashboardPageBlockApi~dashboardPageBlockAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/DashboardPageBlockReport} body 
     * @param {module:api/DashboardPageBlockApi~dashboardPageBlockAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.dashboardPageBlockAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dashboardPageBlockAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling dashboardPageBlockAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/DashboardPageBlock/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the dashboardPageBlockDeleteGet operation.
     * @callback module:api/DashboardPageBlockApi~dashboardPageBlockDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {module:api/DashboardPageBlockApi~dashboardPageBlockDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.dashboardPageBlockDeleteGet = function(_4SAPIAppID, entityID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dashboardPageBlockDeleteGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling dashboardPageBlockDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/DashboardPageBlock/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the dashboardPageBlockEditPut operation.
     * @callback module:api/DashboardPageBlockApi~dashboardPageBlockEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/DashboardPageBlock} body 
     * @param {module:api/DashboardPageBlockApi~dashboardPageBlockEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.dashboardPageBlockEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dashboardPageBlockEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling dashboardPageBlockEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/DashboardPageBlock/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the dashboardPageBlockLoadAlertBlockSlicesPut operation.
     * @callback module:api/DashboardPageBlockApi~dashboardPageBlockLoadAlertBlockSlicesPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/DashboardPageBlockReportNestedPaginationSlice>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAlertBlockSlices
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.startRow  (default to 0)
     * @param {Integer} opts.maxCount  (default to 0)
     * @param {Integer} opts.slicingOrder  (default to 0)
     * @param {module:api/DashboardPageBlockApi~dashboardPageBlockLoadAlertBlockSlicesPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/DashboardPageBlockReportNestedPaginationSlice>}
     */
    this.dashboardPageBlockLoadAlertBlockSlicesPut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dashboardPageBlockLoadAlertBlockSlicesPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling dashboardPageBlockLoadAlertBlockSlicesPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'startRow': opts['startRow'],
        'maxCount': opts['maxCount'],
        'slicingOrder': opts['slicingOrder']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [DashboardPageBlockReportNestedPaginationSlice];

      return this.apiClient.callApi(
        '/DashboardPageBlock/loadAlertBlockSlices', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the dashboardPageBlockLoadCustomTableBlockDataGet operation.
     * @callback module:api/DashboardPageBlockApi~dashboardPageBlockLoadCustomTableBlockDataGetCallback
     * @param {String} error Error message, if any.
     * @param {'String'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadCustomTableBlockData
     * @param {String} _4SAPIAppID 
     * @param {Integer} blockID 
     * @param {Object} opts Optional parameters
     * @param {Date} opts.startDate 
     * @param {Date} opts.endDate 
     * @param {module:api/DashboardPageBlockApi~dashboardPageBlockLoadCustomTableBlockDataGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'String'}
     */
    this.dashboardPageBlockLoadCustomTableBlockDataGet = function(_4SAPIAppID, blockID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dashboardPageBlockLoadCustomTableBlockDataGet";
      }

      // verify the required parameter 'blockID' is set
      if (blockID == undefined || blockID == null) {
        throw "Missing the required parameter 'blockID' when calling dashboardPageBlockLoadCustomTableBlockDataGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'blockID': blockID,
        'startDate': opts['startDate'],
        'endDate': opts['endDate']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'String';

      return this.apiClient.callApi(
        '/DashboardPageBlock/loadCustomTableBlockData', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the dashboardPageBlockLoadDashboardPageBlockSliceGet operation.
     * @callback module:api/DashboardPageBlockApi~dashboardPageBlockLoadDashboardPageBlockSliceGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DashboardPageBlockReportPaginationSlice} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadDashboardPageBlockSlice
     * @param {String} _4SAPIAppID 
     * @param {Integer} pageID 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.maxCommentsCount  (default to 0)
     * @param {module:api/DashboardPageBlockApi~dashboardPageBlockLoadDashboardPageBlockSliceGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/DashboardPageBlockReportPaginationSlice}
     */
    this.dashboardPageBlockLoadDashboardPageBlockSliceGet = function(_4SAPIAppID, pageID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dashboardPageBlockLoadDashboardPageBlockSliceGet";
      }

      // verify the required parameter 'pageID' is set
      if (pageID == undefined || pageID == null) {
        throw "Missing the required parameter 'pageID' when calling dashboardPageBlockLoadDashboardPageBlockSliceGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'pageID': pageID,
        'maxCommentsCount': opts['maxCommentsCount']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = DashboardPageBlockReportPaginationSlice;

      return this.apiClient.callApi(
        '/DashboardPageBlock/loadDashboardPageBlockSlice', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the dashboardPageBlockLoadGet operation.
     * @callback module:api/DashboardPageBlockApi~dashboardPageBlockLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/DashboardPageBlockReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} blockID 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.maxCommentsCount  (default to 0)
     * @param {module:api/DashboardPageBlockApi~dashboardPageBlockLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/DashboardPageBlockReport}
     */
    this.dashboardPageBlockLoadGet = function(_4SAPIAppID, blockID, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling dashboardPageBlockLoadGet";
      }

      // verify the required parameter 'blockID' is set
      if (blockID == undefined || blockID == null) {
        throw "Missing the required parameter 'blockID' when calling dashboardPageBlockLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'blockID': blockID,
        'maxCommentsCount': opts['maxCommentsCount']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = DashboardPageBlockReport;

      return this.apiClient.callApi(
        '/DashboardPageBlock/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
